import { Col, Divider, Form, Input, Row, Select } from "antd"
import React from 'react'

const FormAddress = ({ default_message, estadoOptions, cidadeOptions, loading, handlFetchCEP, handleFetchCidade }: { default_message: string, estadoOptions: any, cidadeOptions: any, loading: any, handlFetchCEP: any, handleFetchCidade: any }) => {
  return (
    <>
      <Divider orientation="left">Endereço</Divider>

      <Row gutter={16}>
        <Col xs={24} md={6}>
          <Form.Item
            name="cep"
            label="CEP"
            rules={[{ required: true, message: default_message }]}
          >
            <Input onChange={e => handlFetchCEP(e.target.value)} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            name="endereco"
            label="Endereço"
            rules={[{ required: true, message: default_message }]}
          >
            <Input maxLength={150} />
          </Form.Item>
        </Col>
        <Col xs={24} md={6}>
          <Form.Item
            name="numero"
            label="Número"
            rules={[{ required: true, message: default_message }]}
          >
            <Input maxLength={10} />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col xs={24} md={12}>
          <Form.Item
            name="bairro"
            label="Bairro"
            rules={[{ required: true, message: default_message }]}
          >
            <Input maxLength={150} />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col xs={24} md={8}>
          <Form.Item
            name="id_estado"
            label="Estado"
            rules={[{ required: true, message: default_message }]}
          >
            <Select
              options={estadoOptions}
              onChange={a => handleFetchCidade(a)}
              loading={loading.estado}
              showSearch
              filterOption={(input, option) =>
                String(option?.label).toLowerCase().indexOf(input.toLowerCase()) === 0
              }
            />
          </Form.Item>
        </Col>
        <Col xs={24} md={8}>
          <Form.Item
            name="id_cidade"
            label="Cidade"
            rules={[{ required: true, message: default_message }]}
          >
            <Select
              options={cidadeOptions}
              disabled={!cidadeOptions.length}
              loading={loading.cidade}
              showSearch
              filterOption={(input, option) =>
                String(option?.label).toLowerCase().indexOf(input.toLowerCase()) === 0
              }
            />
          </Form.Item>
        </Col>
        <Col xs={24} md={8}>
          <Form.Item name="complemento" label="Complemento">
            <Input maxLength={255} />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col xs={24} md={12}>
          <Form.Item name="latitude" label="Latitude">
            <Input maxLength={45} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item name="longitude" label="Longitude">
            <Input maxLength={45} />
          </Form.Item>
        </Col>
      </Row>
    </>
  )
}

export default FormAddress